import { BaseModel } from '@gipi-shared/models/base.model';

export class RegistrationSocialNetworkType extends BaseModel {

    description: string;

}
